var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"topBar"},[_c('Header')],1),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('div',{attrs:{"id":"footer"}},[_c('foot')],1),_c('div',{staticClass:"backTop",attrs:{"id":"backTop"},on:{"click":_vm.toTop}},[_c('i',{staticClass:"el-icon-top"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }